import * as React from 'react';

import "./styles.css";
import { ErrorBoundary } from '../core/BaseApplicationComponents/ErrorBoundary';
import { IStringLocalizer } from '../../utilities/IStringLocalizer';

interface PageProps {
    children: React.ReactNode | React.ReactNode[];
    pageNumber: number;
    currentPage: number;
    // used to localize the fallback message if this page's contents fail to render
    localizer?: IStringLocalizer;
}

// ===============================================================================

export class SurveyActionBar extends React.PureComponent<React.ReactNode | React.ReactNode[]> {
    public render() {
        return (
            <div className="tn-survey-action-bar">
                {this.props.children}
            </div>
        );
    }
}

// ===============================================================================

export class SurveySidebar extends React.PureComponent<React.ReactNode | React.ReactNode[]> {
    public render() {
        return (
            <div className="tn-survey-sidebar">
                <nav>
                    <ul>
                        {this.props.children}
                    </ul>
                </nav>
            </div>
        );
    }
}

// ===============================================================================

export class PageContainer extends React.PureComponent<React.ReactNode | React.ReactNode[]> {
    public render() {
        return (
            <div className="tn-survey-page-container">
                {this.props.children}
            </div>
        );
    }
}

// ===============================================================================
export class Page extends React.PureComponent<PageProps> {
    public render() {

        return (
            <div className={"tn-survey-page" + (this.props.currentPage != this.props.pageNumber ? " hidden" : "")}>
                <ErrorBoundary localizer={this.props.localizer}>{this.props.children}</ErrorBoundary>
            </div>
        );
    }
}
